import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Store, persistor } from "./redux/store";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import App from "./App";
import { app } from "./firebase.config";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={Store} app={app}>
    <PersistGate loading={"loading"} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
